(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   *  simple hierarchical templating service:
   *    
   *  - default templates defined in cardTextTemplates using the format:
   *      {
   *          'section': {
   *              'tags': [param1, param2, param3, ...],
   *              'key1': 'This is a template using a tag {{param1}}'
   *              'key2': 'Any of the tag items can be used in a tag as {{param2}}'
   *              'subSection': {
   *                  'tags': [param4, ...]
   *                  'key1': 'Use tags from this section {{param4}} or parent {{param1}}'
   *                  ...                
   *              }
   *      }
   *  - 'tags' is a reserved key: it can only be used to define the available parameters.
   *  - 'tags' - optional list of values for this section that will be supplied in 'context'.
   *             context.values can be variables or javascript expressions      
   *  - 'keyN' - templates defined for this 'section'
   *   
   *  - sections can be nested within sections
   *  - custom templates are defined in cardConfig.cardText
   *      
   *  Service instances are created and bound to template definitions and cardConfig
   *  using the bind() method:  
   *      var cardText = CardText.bind(cardTextDefinitions, cardConfig) 
   *            
   *  Templates are rendered using the render method: 
   *      var textItem = cardText.render('section.key', {
   *          param1: variable_in_calling_scope,      // variable
   *          param2: some_value * 100                // expression
   *      });
   *      var textItem2 = cardText.render('section.subsection.key');  // no context      
   * 
   **/

  factory('CardText', ['$filter', function ($filter) {
    var CardTextInstance = function CardTextInstance(cardTextTemplates, cardConfig) {
      return {
        templates: cardTextTemplates,
        cardConfig: cardConfig,
        // could be replaced by lodash's _.get(object, path)
        get: function get(object, path) {
          var obj = object;
          path.split('.').forEach(function (part) {
            obj = obj && obj[part];
          });
          return obj;
        },
        // get all tags in path hierarchy
        getTags: function getTags(_path) {
          var self = this,
            path = [],
            tags = [],
            parts = _path.split('.');
          parts.pop(); // remove last key (sibling of 'tags')

          // descend from root, collect tags from each level
          parts.forEach(function (part) {
            path.push(part);
            tags = _.union(tags, self.get(self.templates, path.join('.') + '.tags'));
          });
          return tags;
        },
        // returns template at 'path' with tags replaced with values from 'context'
        render: function render(path, context) {
          var self = this;

          // get template from cardConfig.cardText if it exists, else from templates
          var template = this.get(this.cardConfig.cardText, path);
          if (template === null || _.isUndefined(template)) {
            template = this.get(this.templates, path);
          }
          if (template === null || _.isUndefined(template)) {
            return '"' + path + ': missing template"';
          }

          // replace {{tag}}'s in template with value from context
          return template.replace(/{{(\w+?)}}/g, function (m, tag) {
            // integrity check - is tag in tags
            if (!_(self.getTags(path)).includes(tag)) {
              return '{{' + tag + ': invalid tag}}';
            }
            if (!_(context).has(tag)) {
              return '{{"' + tag + ': value missing"}}';
            }

            // get match value from context & replace
            var value = context[tag];
            if (_.isNumber(value)) {
              return $filter('number')(value);
            }
            return value;
          });
        }
      };
    };
    return {
      bind: function bind(cardTextTemplates, cardConfig) {
        return new CardTextInstance(cardTextTemplates, cardConfig);
      }
    };
  }]);
})();
